import React from 'react';
import PropTypes from 'prop-types';
import Gravatar from 'react-gravatar';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import TimeAgo from 'react-timeago';
import russianStrings from 'react-timeago/lib/language-strings/ru';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';

const formatter = buildFormatter(russianStrings);

const ReviewJson = ({
  name, email, comment, created,
}) => {
  const jsonld = {
    '@type': 'Review',
    url: 'https://dom-yalta.ru/',
    author: {
      '@type': 'Person',
      name,
    },
    publisher: {
      '@type': 'Organization',
      name: 'DOM Yalta',
    },
    datePublished: created,
    description: documentToPlainTextString(comment),
    inLanguage: 'ru',
    reviewRating: {
      '@type': 'Rating',
      worstRating: 1,
      bestRating: 5,
      ratingValue: 5,
    },
  };
  return jsonld;
};

const Review = ({
  name, email, comment, created,
}) => (
  <div className="comment-group">
    <div className="comment-card">
      <div className="comment-thumb">
        <Gravatar
          email={email}
          className="comment-preview"
          default="wavatar"
          alt={name}
          size={56}
        />
      </div>
      <div className="comment-content">
        <div className="comment-title">
          <span className="comment-name">{name}</span>
          <span className="comment-data">
            <TimeAgo date={created} formatter={formatter} />
          </span>
        </div>
        <div className="comment-text">{documentToReactComponents(comment)}</div>
      </div>
    </div>
  </div>
);

Review.JSONLD = ReviewJson;

Review.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  comment: PropTypes.shape().isRequired,
  created: PropTypes.string.isRequired,
};

export default Review;
